import * as ng from 'angular';
import { ForgotPasswordComponent, IForgotPasswordController } from './forgot-password';
import { ResetPasswordComponent, IResetPasswordController } from './reset-password'
import { SecurityComponent, ISecurityController } from './security';
import { SignInComponent, ISignInController } from './sign-in';
import { ProfileSecurity, IProfileSecurityResource } from './data/profile-security';
import { SecurityQuestion, ISecurityQuestionResource } from './data/security-question';
import { User, IUserResource } from './data/user';
import { Auth, IAuthService } from './services/authorization';
import Interceptor from './services/interceptor';
import { PasswordStrength, IPasswordStrengthService } from './services/password-strength';
import { ChangePasswordCardComponent, IChangePasswordCardController } from './user-controls/change-password-card';
import { PasswordComponent, IPasswordController } from './user-controls/password';
import { SecurityQuestionComponent, ISecurityQuestionController } from './user-controls/security-question';
import { SecurityQuestionCardComponent, ISecurityQuestionCardController } from './user-controls/security-question-card';
import { SignInCardComponent, ISignInCardController } from './user-controls/sign-in-card';
import { ICredentials, IToken } from './data/interfaces';
import * as Dto from '../../data/interfaces';

let securityModule = ng.module("app.security", [
    'ngComponentRouter',
    //'ngRouteShim',
    'ngMaterial',
    'ngMessages'

]).config(["$httpProvider", ($httpProvider: ng.IHttpProvider) => {
    $httpProvider.interceptors.push(Interceptor.name);
}])
    .component(ForgotPasswordComponent.name, ForgotPasswordComponent.registration)
    .factory(Interceptor.name, Interceptor.factory)
    .factory(ProfileSecurity.name, ProfileSecurity.factory)
    .factory(SecurityQuestion.name, SecurityQuestion.factory)
    .factory(User.name, User.factory)
    .factory(Auth.name, Auth.factory)
    .factory(PasswordStrength.name, PasswordStrength.factory)
    .component(ChangePasswordCardComponent.name, ChangePasswordCardComponent.registration)
    .component(PasswordComponent.name, PasswordComponent.registration)
    .component(SecurityQuestionComponent.name, SecurityQuestionComponent.registration)
    .component(SecurityQuestionCardComponent.name, SecurityQuestionCardComponent.registration)
    .component(SignInCardComponent.name, SignInCardComponent.registration)
    .component(ResetPasswordComponent.name, ResetPasswordComponent.registration)
    .component(SecurityComponent.name, SecurityComponent.registration)
    .component(SignInComponent.name, SignInComponent.registration);


export {
    securityModule as SecurityModule, securityModule, ICredentials, IToken,
    IForgotPasswordController, IResetPasswordController, ISecurityController, ISignInController,
    IProfileSecurityResource, ISecurityQuestionResource, IUserResource, IAuthService, IPasswordStrengthService,
    IChangePasswordCardController, IPasswordController, ISecurityQuestionController,
    ISecurityQuestionCardController, ISignInCardController, Dto, Interceptor
};
export default securityModule;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/security/index.ts